"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-lines */
var colors_1 = __importStar(require("src/theme/colors"));
var breakpoints_1 = __importDefault(require("src/theme/breakpoints"));
var sizes_1 = __importDefault(require("src/theme/sizes"));
// Font sizes are the proper ones. Figma needs to be updated to proper pixels
var fontSizes = ['0.9rem', '1rem', '1.05rem', '1.1rem', '1.3rem', '1.6rem', '2rem'];
var fontWeights = [400, 700];
var tiny = {
    fonts: {
        small: {
            size: fontSizes[0],
            lineHeight: sizes_1.default[4],
            fontWeight: fontWeights,
        },
        text: {
            size: fontSizes[1],
            lineHeight: sizes_1.default[5],
            fontWeight: fontWeights,
        },
        subheading: {
            size: fontSizes[2],
            lineHeight: sizes_1.default[5],
            fontWeight: fontWeights,
        },
        tertiary: {
            size: fontSizes[3],
            lineHeight: sizes_1.default[5],
            fontWeight: fontWeights,
        },
        secondary: {
            size: fontSizes[4],
            lineHeight: sizes_1.default[6],
            fontWeight: fontWeights,
        },
        primary: {
            size: fontSizes[5],
            lineHeight: sizes_1.default[7],
            fontWeight: fontWeights,
        },
        title: {
            size: fontSizes[6],
            lineHeight: sizes_1.default[8],
            fontWeight: fontWeights,
        },
    },
    inputs: {
        textarea: {
            padding: [sizes_1.default[3], '10px'],
        },
        textInput: {
            padding: [sizes_1.default[3], '10px'],
            iconPadding: [sizes_1.default[3] + " 10px " + sizes_1.default[3] + " 42px", sizes_1.default[3] + " 42px " + sizes_1.default[3] + " 10px"],
        },
    },
    buttons: {
        primary: {
            padding: sizes_1.default[3],
            fontWeight: fontWeights[1],
            borderRadius: sizes_1.default[1],
        },
        secondary: {
            padding: sizes_1.default[3],
            fontWeight: fontWeights[1],
            borderRadius: sizes_1.default[1],
        },
        nav: {
            padding: sizes_1.default[3],
            fontWeight: fontWeights[1],
            borderRadius: sizes_1.default[1],
        },
        naked: {
            padding: sizes_1.default[0],
            fontWeight: fontWeights,
        },
        link: {
            padding: sizes_1.default[0],
            fontWeight: fontWeights,
        },
    },
};
var palette = {
    font: {
        light: [colors_1.default.gray850, colors_1.default.gray600, colors_1.default.red700, colors_1.default.yellow700, colors_1.default.green700],
        dark: [colors_1.default.grayBlue200, colors_1.default.grayBlue400, colors_1.default.red700, colors_1.default.yellow700, colors_1.default.green700],
    },
    border: {
        light: [colors_1.default.gray400],
        dark: [colors_1.default.transparent],
    },
    elevation: {
        light: [
            'initial',
            '0px 1px 2px rgba(0, 0, 0, 0.20)',
            '0px 2px 4px rgba(0, 0, 0, 0.20)',
            '0px 4px 8px rgba(0, 0, 0, 0.20)',
            '0px 8px 16px rgba(0, 0, 0, 0.20)',
            '0px 12px 24px rgba(0, 0, 0, 0.20)',
        ],
        dark: [
            'initial',
            '0px 2px 2px rgba(255, 255, 255, 0.40)',
            '0px 4px 4px rgba(255, 255, 255, 0.40)',
            '0px 6px 8px rgba(255, 255, 255, 0.40)',
            '0px 8px 16px rgba(255, 255, 255, 0.40)',
            '0px 12px 24px rgba(255, 255, 255, 0.40)',
        ],
    },
    inputBg: {
        light: [colors_1.default.white],
        dark: [colors_1.default.transparent],
    },
    inputBorder: {
        light: [
            colors_1.default.gray500,
            colors_1.default.green500,
            colors_1.default.red500, // on error message
        ],
        dark: [colors_1.default.grayBlue700, colors_1.default.green500, colors_1.default.red500],
    },
    inputBorderActive: {
        light: [colors_1.default.gray700],
        dark: [colors_1.default.grayBlue200],
    },
    inputPlaceholder: {
        light: [colors_1.default.gray600],
        dark: [colors_1.default.grayBlue500],
    },
    inputTextColor: {
        light: [colors_1.default.gray850],
        dark: [colors_1.default.grayBlue200],
    },
    inputRadioBg: {
        light: [colors_1.default.white],
        dark: [colors_1.default.gray920],
    },
    inputRadioBgChecked: {
        light: [colors_1.default.brand500],
        dark: [colors_1.default.brand500],
    },
    inputRadioBorder: {
        light: [colors_1.default.gray500],
        dark: [colors_1.default.grayBlue700],
    },
    inputRadioBorderHover: {
        light: [colors_1.default.gray850],
        dark: [colors_1.default.grayBlue200],
    },
    inputCheckBoxBg: {
        light: [colors_1.default.white],
        dark: [colors_1.default.transparent],
    },
    inputCheckBoxBgChecked: {
        light: [colors_1.default.brand500, colors_1.default.white],
        dark: [colors_1.default.brand500, colors_1.default.transparent],
    },
    inputCheckBoxBorder: {
        light: [colors_1.default.gray500],
        dark: [colors_1.default.grayBlue700],
    },
    inputCheckBoxBorderHover: {
        light: [colors_1.default.gray700],
        dark: [colors_1.default.grayBlue200],
    },
    inputIconColor: {
        light: [colors_1.default.gray500, colors_1.default.gray850],
        dark: [colors_1.default.grayBlue700, colors_1.default.grayBlue200],
    },
    inputSwitchBg: {
        light: [colors_1.default.grayBlue200],
        dark: [colors_1.default.grayBlue800],
    },
    inputSwitchBgChecked: {
        light: [colors_1.default.brand500],
        dark: [colors_1.default.brand500],
    },
    fieldError: {
        light: [colors_1.default.red700],
    },
    buttonBg: {
        light: [colors_1.default.blue600, colors_1.default.transparent, colors_1.default.gray200, colors_1.default.brand500],
        dark: [colors_1.default.blue600, colors_1.default.transparent, colors_1.default.transparent, colors_1.default.brand500], // primary, secondary, naked, brand
    },
    buttonBgHover: {
        light: [colors_1.default.blue700, colors_1.default.white, colors_1.default.gray300, colors_1.default.brand500],
        dark: [colors_1.default.blue400, colors_1.default.transparent, colors_1.default.transparent, colors_1.default.brand500], // primary, secondary, naked, brand
    },
    buttonBgActive: {
        light: [colors_1.default.blue800, colors_1.default.gray400, colors_1.default.gray400, colors_1.default.brand500],
        dark: [colors_1.default.blue300, colors_1.default.grayBlue800, colors_1.default.grayBlue800, colors_1.default.brand500], // primary, secondary, naked, brand
    },
    buttonBorder: {
        light: [colors_1.default.gray500, colors_1.default.grayBlue300],
        dark: [colors_1.default.grayBlue700, colors_1.default.grayBlue300], // secondary, nav
    },
    buttonBorderHover: {
        light: [colors_1.default.gray850],
        dark: [colors_1.default.grayBlue200],
    },
    buttonColor: {
        light: [
            colors_1.default.gray100,
            colors_1.default.gray850,
            colors_1.default.grayBlue700,
            colors_1.default.blue600,
            colors_1.default.gray850,
            colors_1.default.gray850, // linkTertiary
        ],
        dark: [
            colors_1.default.gray100,
            colors_1.default.grayBlue200,
            colors_1.default.grayBlue200,
            colors_1.default.blue400,
            colors_1.default.grayBlue200,
            colors_1.default.grayBlue200, // linkTertiary
        ],
    },
    buttonColorHover: {
        light: [
            colors_1.default.gray100,
            colors_1.default.gray850,
            colors_1.default.grayBlue700,
            colors_1.default.blue600,
            colors_1.default.blue600,
            colors_1.default.gray850, // linkTertiary
        ],
        dark: [
            colors_1.default.gray100,
            colors_1.default.grayBlue200,
            colors_1.default.grayBlue300,
            colors_1.default.blue400,
            colors_1.default.blue400,
            colors_1.default.grayBlue200, // linkTertiary
        ],
    },
    bannerBackground: {
        light: [
            colors_1.default.gray100,
            colors_1.default.yellow100,
            colors_1.default.green100,
            colors_1.default.red100, // error
        ],
        dark: [
            colors_1.default.grayBlue850,
            colors_1.default.yellow100,
            colors_1.default.green100,
            colors_1.default.red100, // error
        ],
    },
    bannerBorder: {
        light: [
            colors_1.default.gray500,
            colors_1.default.yellow700,
            colors_1.default.green700,
            colors_1.default.red700, // error
        ],
        dark: [
            colors_1.default.grayBlue700,
            colors_1.default.yellow700,
            colors_1.default.green700,
            colors_1.default.red700, // error
        ],
    },
    bannerTextColor: {
        light: [colors_1.default.gray850, colors_1.default.gray850],
        dark: [colors_1.default.grayBlue200, colors_1.default.gray850],
    },
    dropdownColor: {
        light: [colors_1.default.gray850, colors_1.default.gray500],
        dark: [colors_1.default.grayBlue200, colors_1.default.grayBlue700], // active, disabled
    },
    dropdownBackground: {
        light: [colors_1.default.white, colors_1.default.grayBlue200, colors_1.default.gray100],
        dark: [colors_1.default.grayBlue900, colors_1.default.grayBlue800, colors_1.default.grayBlue850], // default, hover, active
    },
    dropdownBoxShadow: {
        light: [
            "0 0 0 1px " + colors_1.default.gray500,
            "0 0 0 1px " + colors_1.default.gray850,
            "0 0 0 1px " + colors_1.default.gray850,
        ],
        dark: [
            "0 0 0 1px " + colors_1.default.grayBlue700,
            "0 0 0 1px " + colors_1.default.gray200,
            "0 0 0 1px " + colors_1.default.gray200,
        ],
    },
    boxCardBackground: {
        light: colors_1.default.white,
        dark: colors_1.default.gray850,
    },
    boxCardBorder: {
        light: colors_1.default.gray300,
        dark: colors_1.default.transparent,
    },
};
var bestPriceTheme = {
    breakpoints: { TINY: tiny },
    supportedBreakpoints: breakpoints_1.default,
    heuristicBreakpoints: {
        small: breakpoints_1.default.slice(0, 4),
        medium: breakpoints_1.default.slice(4, 7),
        large: breakpoints_1.default.slice(7),
    },
    sizes: {
        default: sizes_1.default,
    },
    palette: palette,
    colors: colors_1.default,
    darkDefaults: colors_1.darkDefaults,
    opacity: [0.1, 0.4, 0.8],
};
exports.default = bestPriceTheme;
